import { render, staticRenderFns } from "./ehc-show-obj.vue?vue&type=template&id=5f76d5a9"
import script from "./ehc-show-obj.vue?vue&type=script&lang=js"
export * from "./ehc-show-obj.vue?vue&type=script&lang=js"
import style0 from "./ehc-show-obj.vue?vue&type=style&index=0&id=5f76d5a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports